module.exports = __webpack_public_path__ + "img/newyear_know_btn.517ab064.png";